module.exports = __webpack_public_path__ + "static/media/gallerium.f0be6b1c.jpg";